<div *ngIf="ViewReady">
    <h2 class="mat-title">
        DELTA Issue Reports Tracker
    </h2>
    <div>
        <div>There are currently {{IssuesList?.length || 0}} Issue Reports in the DELTA System.</div>
        <div>You may view all Issue Reports filed by users of the DELTA System below. Use the filters provided to analyze, sort, or otherwise manage the display of the Issue Reports on file.</div>
    </div>

    <!-- New User Form
    <div [hidden]="!ShowingNewUserForm" class="mat-elevation-z12 padding">
        <h2 class="mat-headline">New User Panel</h2>
        <div>
            <p>This panel can be used to create a new user account for individuals who need access to the DELTA System as college advisors or administrators. You should <strong>not</strong> use this panel to create a new user account for any other individuals such as parents, students, or school staff.</p>
            <p>Use the form below to provide the required information to generate an account. The username for the account is automatically assigned by the district user account system. A randomly generated secure default password will be assigned to all new accounts created.</p>
            <p><strong>Note: </strong>The user whose account is being created <u>will</u> be emailed the account information along with instructions on how to use the district Password Reset Tool to change their default password.</p>
        </div>
        <form [formGroup]="NewUserForm" novalidate>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <form-label>First Name: </form-label>
                    <mat-form-field>
                        <input type="text" matInput formControlName="FirstName" placeholder="First Name..." maxlength="50" />
                        <mat-error *ngIf="NewUserForm.controls['FirstName'].hasError('required')">User first name required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <form-label>Last Name: </form-label>
                    <mat-form-field>
                        <input type="text" matInput formControlName="LastName" placeholder="Last Name..." maxlength="50" />
                        <mat-error *ngIf="NewUserForm.controls['LastName'].hasError('required')">User last name required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <form-label>Email: </form-label>
                    <mat-form-field>
                        <input type="text" matInput formControlName="Email" placeholder="Email Address..." maxlength="100" />
                        <mat-error *ngIf="NewUserForm.controls['Email'].hasError('required')">User email address required</mat-error>
                        <mat-error *ngIf="NewUserForm.controls['Email'].hasError('validateEmail')">Invalid email address format</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <form-label>Email Verification: </form-label>
                    <mat-form-field>
                        <input type="text" matInput formControlName="EmailVerify" placeholder="Email Address Verification..." maxlength="100" [errorStateMatcher]="parentErrorStateMatcher" />
                        <mat-error *ngIf="NewUserForm.controls['EmailVerify'].hasError('required')">User email address required</mat-error>
                        <mat-error *ngIf="NewUserForm.controls['EmailVerify'].hasError('validateEmail')">Invalid email address format</mat-error>
                        <mat-error *ngIf="NewUserForm.hasError('EmailVerifyValidate') && !NewUserForm.controls['EmailVerify'].errors">Verification email does not match original email</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="actionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
            <button type="text" mat-raised-button color="primary" (click)="AddNewUser(1)" [disabled]="NewUserForm.invalid">Add User As Advisor</button>
            <button type="text" mat-raised-button color="primary" (click)="AddNewUser(2)" [disabled]="NewUserForm.invalid">Add User As Administrator</button>
            <button type="text" mat-raised-button color="warn" (click)="ResetNewUserForm()">Cancel</button>
        </div>
    </div> -->

    <form>
        <form-label>Display Filter: </form-label>
        <mat-form-field class="displaylist">
            <mat-select [(ngModel)]="IssueDisplayMode" [ngModelOptions]="{standalone: true}" (change)="UpdateIssueDisplayMode($event)">
                <mat-option value="A">All Issue Reports</mat-option>
                <mat-option value="U">Open / Unresolved Issue Reports</mat-option>
                <mat-option value="R">Closed / Resolved Issue Reports</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
    <!-- Issues Table -->
    <mat-table class="bordered" #table [dataSource]="IssuesData" matSort matSortActive="DateReported" matSortDirection="desc">
        <ng-container matColumnDef="IssueNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered"><span>Issue #</span></mat-header-cell>
            <mat-cell *matCellDef="let issue" class="centered"><span>{{issue.WebAppIssueReportID}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="DateReported">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Date Reported</mat-header-cell>
            <mat-cell *matCellDef="let issue" class="centered">
                <span *ngIf="issue.DateReported">{{issue.DateReported | datefns:'M/D/YYYY h:mm A'}}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ReporterName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Reported By</mat-header-cell>
            <mat-cell *matCellDef="let issue" class="centered"><span>{{issue.ReportedByLastName | titleCase}}, {{issue.ReportedByFirstName | titleCase}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Issue">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Issue</mat-header-cell>
            <mat-cell *matCellDef="let issue" class="centered"><span>{{issue.IssueName}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Status">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Resolved?</mat-header-cell>
            <mat-cell *matCellDef="let issue" class="centered"><span>{{issue.Resolved | yesNo}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="ResolverName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Resolved By</mat-header-cell>
            <mat-cell *matCellDef="let issue" class="centered">
                <span *ngIf="issue.ResolvedByLastName">{{issue.ResolvedByLastName | titleCase}}, {{issue.ResolvedByFirstName | titleCase}}</span>
                <span>{{issue.ResolvedDate | datefns:'M/D/YYYY h:mm A'}}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let issue" class="centered">
                <div class="padding-top padding-bottom" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                    <button mat-raised-button color="primary" (click)="ViewIssueReportDetail(issue)">
                        <span>View Details</span>
                    </button>
                    <button *ngIf="!issue.Resolved && User.IsDeveloper" mat-raised-button color="accent" (click)="ResolveIssue(issue)">
                        <span>Resolve</span>
                    </button>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Issue Report(s)</mat-header-cell>
            <mat-cell *matCellDef="let issue">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Issue #</form-label>
                        <span>{{issue.WebAppIssueReportID}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Date Reported</form-label>
                        <span *ngIf="issue.DateReported">{{issue.DateReported | datefns:'M/D/YYYY h:mm A'}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Reported By</form-label>
                        <span>{{issue.ReportedByLastName | titleCase}}, {{issue.ReportedByFirstName | titleCase}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Issue</form-label>
                        <span>{{issue.IssueName}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Resolved</form-label>
                        <span>{{issue.Resolved | yesNo}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <form-label>Resolved By</form-label>
                        <div *ngIf="issue.ResolvedByLastName" fxLayout="column" fxLayoutAlign="start end">
                            <span *ngIf="issue.ResolvedByLastName">{{issue.ResolvedByLastName | titleCase}}, {{issue.ResolvedByFirstName | titleCase}}</span>
                            <span>{{issue.ResolvedDate | datefns:'M/D/YYYY h:mm A'}}</span>
                        </div>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button mat-raised-button color="primary" (click)="ViewIssueReportDetail(issue)">
                            <span>View Details</span>
                        </button>
                        <button *ngIf="!issue.Resolved && User.IsDeveloper" mat-raised-button color="primary" (click)="ResolveIssue(issue)">
                            <span>Resolve</span>
                        </button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let issue"><em>
                <span *ngIf="IssueDisplayMode == 'A'">No Issue Reports have been filed for the DELTA System.</span>
                <span *ngIf="IssueDisplayMode != 'A' && !!IssuesList.length">No Issue Reports matching the specified filter have been filed for the DELTA System.</span>
            </em></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row;columns: VisibleColumns;let $even = even" [class.primarybackground50]="$even && row.Resolved" [class.red500-02]="!row.Resolved"></mat-row>
    </mat-table>
    <mat-paginator #paginator [length]="FilteredIssuesList?.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

    <div *ngIf="User.IsDeveloper" class="margin-bottom">
        <h2>Available Issue Types</h2>

        <div class="mat-elevation-z12 padding">
            <form [formGroup]="NewIssueTypeForm" novalidate>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                    <div fxFlex.gt-sm="65" fxFlex.lt-md="auto" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                        <form-label>Display Text: </form-label>
                        <mat-form-field fxFlex>
                            <input type="text" matInput formControlName="DisplayText" placeholder="Display text..." maxlength="250" />
                            <mat-error *ngIf="NewIssueTypeForm.get('DisplayText').hasError('required')">Display text required</mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                        <mat-checkbox formControlName="RequiresDescription">Requires Description</mat-checkbox>
                    </div>
                </div>
            </form>
            <div class="actionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
                <button type="text" mat-raised-button color="primary" (click)="AddNewIssueType()" [disabled]="NewIssueTypeForm.invalid">Add Issue Type</button>
                <button type="text" mat-raised-button color="warn" (click)="NewIssueTypeForm.reset()">Reset</button>
            </div>
        </div>

        <!-- Issue Types Table -->
        <mat-table class="bordered" #issuetable [dataSource]="AvailableIssuesData">
            <ng-container matColumnDef="IssueID">
                <mat-header-cell *matHeaderCellDef class="centered"><span>Issue ID</span></mat-header-cell>
                <mat-cell *matCellDef="let issue" class="centered"><span>{{issue.IssueID}}</span></mat-cell>
            </ng-container>

            <ng-container matColumnDef="DisplayText">
                <mat-header-cell *matHeaderCellDef class="centered">Display Text</mat-header-cell>
                <mat-cell *matCellDef="let issue" class="centered">
                    <div>{{issue.DisplayText}}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="RequiresDescription">
                <mat-header-cell *matHeaderCellDef class="centered">Requires Description</mat-header-cell>
                <mat-cell *matCellDef="let issue" class="centered">
                    <span>{{issue.RequiresDescription | yesNo}}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="InUse">
                <mat-header-cell *matHeaderCellDef class="centered">In Use</mat-header-cell>
                <mat-cell *matCellDef="let issue" class="centered">
                    <span>{{issue.InUse | yesNo}}</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="SortOrder">
                <mat-header-cell *matHeaderCellDef class="centered">Sort Order</mat-header-cell>
                <mat-cell *matCellDef="let issue" class="centered"><span>{{issue.SortOrder}}</span></mat-cell>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
                <mat-cell *matCellDef="let issue; let $first = first; let $last = last" class="centered">
                    <div class="padding-top padding-bottom" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <button *ngIf="!$first" mat-icon-button color="primary" (click)="MoveIssueUpward(issue)">
                                <mat-icon>arrow_upward</mat-icon>
                            </button>
                            <button *ngIf="!$last" mat-icon-button color="primary" (click)="MoveIssueDownward(issue)">
                                <mat-icon>arrow_downward</mat-icon>
                            </button>
                        </div>
                        <div>
                            <button *ngIf="!issue.InUse" mat-raised-button color="warn" (click)="RemoveIssueType(issue)">Remove</button>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="SmallDisplay">
                <mat-header-cell *matHeaderCellDef class="centered">Issue Type(s)</mat-header-cell>
                <mat-cell *matCellDef="let issue; let $first = first; let $last = last">
                    <div fxLayout="column" fxLayoutAlign="start stretch">
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <form-label>Issue ID</form-label>
                            <span>{{issue.IssueID}}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <form-label>Display Text</form-label>
                            <span>{{issue.DisplayText}}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <form-label>Requires Description</form-label>
                            <span>{{issue.RequiresDescription | yesNo}}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <form-label>In Use</form-label>
                            <span>{{issue.InUse | yesNo}}</span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <form-label>Sort Order</form-label>
                            <span>{{issue.SortOrder}}</span>
                        </div>
                        <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <button *ngIf="!$first" mat-icon-button color="primary" (click)="MoveIssueUpward(issue)">
                                <mat-icon>arrow_upward</mat-icon>
                            </button>
                            <button *ngIf="!$last" mat-icon-button color="primary" (click)="MoveIssueDownward(issue)">
                                <mat-icon>arrow_downward</mat-icon>
                            </button>
                            <!-- <button mat-raised-button color="primary" (click)="ViewIssueReportDetail(issue)">
                                <span>View Details</span>
                            </button>
                            <button *ngIf="!issue.Resolved && User.IsDeveloper" mat-raised-button color="primary" (click)="ResolveIssue(issue)">
                                <span>Resolve</span>
                            </button> -->
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="NoData">
                <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
                <mat-cell *matCellDef="let issue"><em>No issue types have been defined in the DELTA System.</em></mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="AvailableIssuesVisibleHeaders"></mat-header-row>
            <mat-row *matRowDef="let row;columns: AvailableIssuesVisibleColumns;let $even = even" [class.primarybackground50]="$even"></mat-row>
        </mat-table>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/issuereportreview/issuereportreview.component.html